import { Inject, Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { from, lastValueFrom, map } from "rxjs";
import { HarloweSupport } from "../models/support";
import { ApiService } from "./api.service";
import { BASE_URL } from "./injection-tokens";

export abstract class UtilServiceBase
{
    abstract getFileBlob(file: HarloweSupport.File): Promise<Blob>;
    abstract getFileImageURL(file: HarloweSupport.File): Promise<string>;
}



@Injectable({providedIn: 'root'})
export class UtilService extends UtilServiceBase
{
    constructor(private _api: ApiService, @Inject(BASE_URL) private _baseUrl: string, private sanitizer:DomSanitizer)
    {
        super();
    }



    override getFileImageURL(file: HarloweSupport.File): Promise<string> 
    {
        //Get the data
        return lastValueFrom(this._api.getFileBlob(this._baseUrl,"/util/files/"+file.id.toString())
        .pipe
        (
            map
            (
                f =>
                {
                    const unsafeUrl = URL.createObjectURL(f)                    
                    return unsafeUrl;
                }    
            )
        ));
    }



    override getFileBlob(file: HarloweSupport.File): Promise<Blob>
    {
        return lastValueFrom
        (
            this._api.getFileBlob(this._baseUrl,"/util/files/"+file.id.toString())
        );
    }




}